import React, { Component } from 'react';
import uuid from 'uuid';

import firebase from '../config/firebase';

class UploadButton extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isUploading: false
    }
  }

  handleClick() {
    const input = document.createElement("INPUT");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/gif, image/jpeg, image/png");
    input.addEventListener("change", ({target: {files: [file]}}) => this.uploadFile(file));
    input.click();
  }

  uploadFile(file) {
    console.log('F', file);
    const id = uuid.v4();
    this.setState({ isUploading: true })
    const metadata = {
      contentType: file.type
    };
    firebase.storage()
      .ref('friends')
      .child(id)
      .put(file, metadata)
      .then((data) => {
        firebase.storage().ref('friends').child(id).getDownloadURL()
          .then((downloadURL) => {
            this.setState({ isUploading: false })
            console.log('Uploaded', downloadURL);
            this.props.onUploadComplete(downloadURL);
          })
      })
      .catch(e => {
        this.setState({ isUploading: false })
        alert(e)
      });

  }

  render() {
    const {
      props: {
        value,
        style = {},
        className = "image-upload-button",
      },
      state: {
        isUploading
      }
    } = this;

    return (
      <div
        onClick={() => this.handleClick()}
        className={className}
        style={{
          ...style,
          backgroundImage: `url("${this.props.value}")`,
        }}>
        {isUploading ? "UPLOADING..." : !value ? 'No image' : ''}
      </div>
    );
  }

}

export default UploadButton;
